<template>
  <Tracking/>
</template>

<script>
import Tracking from "./Tracking";
import service from "./../service";

export default {
  name: "GetToKnow",
  data() {
    return {

    };
  },
  methods: {
    
  },
  mounted() {
    let specialDestination = false;
    for (let key in this.$route.query) {
      console.log(key);
      if (key == "notificacao") {
        specialDestination = true;
        service.getNotificationRedirectUrl().then(result => {
          try {
            window.location.href = result.url;
          } catch {

          }
        }).catch(() => {

        });
      } else if (key == "mentoria") {
        specialDestination = true;
        setTimeout(function() {
          window.location.href = "https://youtu.be/AqYMxREOe-w";
        }, 800)
      } else if (key == "youtube") {
        specialDestination = true;
        setTimeout(function() {
          window.location.href = "https://www.youtube.com/channel/UCL0qNQWgkDKudln08n9WvHg";
        }, 800)
      } else if (key == "youtube-live-patrocinado") {
        specialDestination = true;
        setTimeout(function() {
          window.location.href = "https://www.youtube.com/watch?v=LbTxniP6Sqg";
        }, 800)
      } else if (key == "whatsapp_sales") {
        specialDestination = true;
        setTimeout(function() {
          window.location.href = "https://api.whatsapp.com/send?l=pt_BR&phone=5541984049884&text=Ol%C3%A1!%20Tenho%20uma%20d%C3%BAvida%20para%20contratar%20o%20Sleeker,%20pode%20me%20ajudar?";
        }, 800)
      }
    }
    
    if (!specialDestination) {
      this.$router.push("/");
      //window.location.href = "https://conheca.sleeker.pt";
    }
  },
  components: { Tracking }
};
</script>